import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import types from "../data/dialogTypes";


export interface diagProps {
	owner: object;
	onClose: (value: string) => void;
}

const { Formik } = formik;


class DialogDialog extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

	handleSubmit(data, { resetForm }){

		
		this.updateStatus({sent:false, success:false, message:'Adding dialog...'});
		//saveguard for testing

		var data = {...data,
			projectId: this.props.projectid
		}

		
		
		//console.log(setMainScenario);
		atlasApi.addDialog(this.props.owner.id, data).then((response)=>{
			if(response.id){
				this.updateStatus({sent:true, success:true, message:'Your dialog was added'});
				
				if(this.props.onAdd)
					this.props.onAdd({...data, ...{id:response.id}});
				resetForm();
				setTimeout(()=>this.handleClose(), 1);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error adding dialog'});
			
			
			
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error adding dialog'});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};


	render() {
		return (
				<Formik validationSchema={schemas.dialog} onSubmit={this.handleSubmit.bind(this)} initialValues={{dialogType:types[0].value}}>	
					{({ handleSubmit, handleChange, values, touched, errors }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
									
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												
												<Form.Select name="dialogType" defaultValue={values.type ? values.type : null} options={types} onChange={handleChange}>
													{types.map(option => (
														<option key={option.value} value={option.value}>{option.label}</option>
													))}
												</Form.Select>
												<Form.Control.Feedback>Looks good!</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row>
											<Form.Group as={Col} md="12" controlId="validationFormik00">
												
												<Form.Control as="textarea" name="text" onChange={handleChange} placeholder="Write your message here" isValid={touched.text && !errors.text} isInvalid={errors.text}/>
											</Form.Group>
											
											<Form.Control.Feedback>
												{errors.message}
											</Form.Control.Feedback>
										</Row>
									</Modal.Body>
									
									<Modal.Footer className="mt-3">
										<Button variant="primary" type="submit">Add dialog</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
		);
	}
}

export default DialogDialog;